import { localStorageSafe } from '../utils'
import { BASE_URL } from './index'

const axios = require('axios')

export const getAxios = () => {
  axios.defaults.baseURL = BASE_URL
  // axios.defaults.baseURL = 'https://api.run24hrs.com/'

  if (localStorageSafe && localStorage.getItem('run-24-hrs-token')) {
    axios.defaults.headers.common.Authorization = `Token ${localStorage.getItem(
      'run-24-hrs-token'
    )}`
  }
  return axios
}



// WEBPACK FOOTER //
// /opt/build/repo/src/api/axiosWithToken.js